import { Theme } from '@mui/material/styles';
import '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import {
  APP_FONT_WEIGHT_BOLD,
  APP_FONT_WEIGHT_SEMIBOLD,
} from '@common/styles/fonts';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
  interface DefaultTheme extends Theme {}
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    notificationModalContainer: {
      position: 'fixed',
      right: 15,
      top: 60,
      width: 600,
      height: 'auto',
      minHeight: 100,
      maxHeight: 500,
      overflow: 'auto',
      borderColor: theme.palette.background.default,
      borderWidth: 4,
      backgroundColor: theme.palette.primary.contrastText,
      boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
      borderRadius: 5,
      modal: 1300,
    },
    notificationHeader: {
      fontWeight: APP_FONT_WEIGHT_BOLD,
      height: 50,
      border: 0,
      borderBottom: 1,
      borderStyle: 'solid',
      backgroundColor: theme.palette.info.light,
    },
    notificationTitle: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      top: 15,
    },
    notificationTitleText: {
      marginRight: 15,
      fontSize: '1rem',
      color: theme.palette.info.dark,
    },
    notificationCount: {
      top: '10px',
      color: theme.palette.info.dark,
      height: '20px',
      width: '20px',
      borderRadius: '50%',
      borderColor: theme.palette.info.dark,
      borderWidth: 1,
    },
    notificationClose: {
      position: 'relative',
      float: 'right',
      right: '5px',
      top: '-22px',
    },
    notificationDetails: {
      paddingTop: '10px',
      paddingBottom: '20px',
      marginLeft: '15px',
      marginRight: '0px',
      color: theme.palette.info.dark,
      fontSize: '14px',
      fontWeight: 400,
    },
    notificationDetail: {
      borderTop: '1px',
      marginLeft: '10px',
      padding: '10px 5px 5px 10px',
      borderColor: theme.palette.info.main,
      minHeight: '50px',
      width: '95%',
      '&:hover': {
        borderRadius: 5,
        transition: 'backgroundColor 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        backgroundColor: theme.palette.info.light,
      },
    },
    notificationProcessIcon: {
      marginLeft: '15px',
      marginRight: '20px',
    },
    progressSpinner: {
      color: theme.palette.info.main,
    },
    notificationLink: {
      display: 'block',
      paddingRight: '15px',
      color: 'black',
      fontSize: '14px',
      fontWeight: APP_FONT_WEIGHT_SEMIBOLD,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    notificationProcess: {
      fontSize: '12px',
    },
    actionButton: {
      width: 32,
      height: 32,
    },
    actions: {
      marginLeft: '10px',
    },
  })
);
